import { RootState } from "../../rootReducer";

export const selectIsUpdatingStressCheck = (state: RootState) =>
  state.updateStressCheck.loading;
export const selectIsUpdated = (state: RootState) =>
  state.updateStressCheck.saved;
export const selectUpdateErrorMessage = (state: RootState) =>
  state.updateStressCheck.error;
export const updateStressCheckDataResponse = (state: RootState) =>
  state.updateStressCheck.updateStressCheckResponse;
